<template>
  <div class="content-wrapper" style="background-color: #f8f9fb;">
    <router-view></router-view>
    <SignIn v-if="showSignIn"></SignIn>
    <SIgnUp v-if="showSignUp"></SIgnUp>
    <SnackBar :snackbarInfo="snackbarInfo"></SnackBar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "default",
  components: {},
  data() {
    return {
      snackbarInfo: {
        status: false,
        color: "info",
        msg: "登录成功",
        timeout: 2000,
      },
      dialog: false,
    };
  },
  computed: {
    ...mapState(["showSignIn", "showSignUp", "snackInfo"]),
  },
  watch: {
    snackInfo: {
      handler(newV) {
        this.snackbarInfo = newV;
        let msg = "tips." + newV.msg;
        this.snackbarInfo.msg = this.$i18n.t(msg);
      },
    },
    showSignUp: {
      handler(newV) {
        if (newV) {
          this.dialog = true;
        }
      },
    },
    showSignIn: {
      handler(newV) {
        if (newV) {
          this.dialog = true;
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import "../utils/common.scss";

.content-wrapper {
  width: 100%;
  flex-grow: 1;
  display: flex;
  margin-top: 64px;
  min-width: 800px;
}
</style>
